import type { ViewQuery, ViewQueryMultiTablePivotQuery, ViewQueryResult } from '../../schemas/query/index.ts'
import type { NodePredicateResolver } from './executeViewQuery/generateSql.ts'
import { executeViewQueryForAggregationQuery, type SqlClient } from './executeViewQueryForAggregationQuery.ts'
import { executeViewQueryForListQuery } from './executeViewQueryForListQuery.ts'
import { executeViewQueryForMultiTablePivot } from './executeViewQueryForMultiTablePivot.ts'
import type { ViewResultCursorOrInitialCursor } from './types.ts'

const DEFAULT_PAGE_SIZE = 100

export const defaultCursor: ViewResultCursorOrInitialCursor = {
  page: 1,
  // eslint-disable-next-line sonarjs/todo-tag
  pageSize: DEFAULT_PAGE_SIZE, // TODO: positive validation[]
  chunkSize: 0, // chunkSizeは前回取得時の最後の行数で決まるので、デフォルトは0でOK
  nextId: undefined,
}

export const executeViewQuery = async ({
  viewQuery,
  sqlClient,
  cursor,
  mustacheParameter,
  dateForDiffHighlight,
  shouldJoinRecordsInApplication,
  unlimitedRowsEnabled,
  accountClosingMonth,
  sqlOverrideResolver,
  resolveNodePredicate,
  posthogTrack,
}: {
  viewQuery: ViewQuery
  sqlClient: SqlClient
  cursor?: ViewResultCursorOrInitialCursor
  mustacheParameter: Record<string, unknown>
  dateForDiffHighlight?: Date
  shouldJoinRecordsInApplication?: boolean
  unlimitedRowsEnabled?: boolean
  accountClosingMonth: number
  sqlOverrideResolver?: (rawSql: string) => Promise<string | undefined>
  resolveNodePredicate: NodePredicateResolver
  posthogTrack?: (duration: number, query: ViewQueryMultiTablePivotQuery) => void
}): Promise<ViewQueryResult> => {
  switch (viewQuery.type) {
    case 'aggregation': {
      return await executeViewQueryForAggregationQuery({
        query: viewQuery,
        sqlClient,
        mustacheParameter,
        accountClosingMonth,
        sqlOverrideResolver,
        resolveNodePredicate,
      })
    }
    case 'multiTablePivot': {
      return await executeViewQueryForMultiTablePivot({
        query: viewQuery,
        sqlClient,
        mustacheParameter,
        unlimitedRowsEnabled: unlimitedRowsEnabled ?? false,
        accountClosingMonth,
        sqlOverrideResolver,
        posthogTrack,
        resolveNodePredicate,
      })
    }
    case 'list': {
      return await executeViewQueryForListQuery({
        viewQuery,
        sqlClient,
        cursor,
        mustacheParameter,
        dateForDiffHighlight,
        shouldJoinRecordsInApplication,
        accountClosingMonth,
        sqlOverrideResolver,
        resolveNodePredicate,
      })
    }
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    default: {
      // eslint-disable-next-line sonarjs/no-dead-store,sonarjs/no-unused-vars
      const x: never = viewQuery
      throw new Error(`unsupported viewQuery type`)
    }
  }
}
